import React, {createContext, useCallback, useContext, useState} from 'react';

const HasPendingItemDeletionContext = createContext(false);

const noopRegister = () => () => {};

const RegisterPendingItemDeletionContext =
  createContext<() => VoidFunction>(noopRegister);

/**
 * Tracks basket items with a deletion in progress (undo window or request in
 * flight), so other basket mutations (e.g. the coins toggle) can be blocked
 * until the deletion settled. Without the provider, tracking is a no-op.
 */
export const BasketPendingItemDeletionsProvider: React.FC<
  React.PropsWithChildren
> = ({children}) => {
  const [pendingCount, setPendingCount] = useState(0);

  const registerPendingItemDeletion = useCallback(() => {
    setPendingCount(count => count + 1);

    let ended = false;
    return () => {
      if (!ended) {
        ended = true;
        setPendingCount(count => count - 1);
      }
    };
  }, []);

  return (
    <RegisterPendingItemDeletionContext.Provider
      value={registerPendingItemDeletion}
    >
      <HasPendingItemDeletionContext.Provider value={pendingCount > 0}>
        {children}
      </HasPendingItemDeletionContext.Provider>
    </RegisterPendingItemDeletionContext.Provider>
  );
};

export const useHasPendingItemDeletion = () =>
  useContext(HasPendingItemDeletionContext);

export const useRegisterPendingItemDeletionCallback = () =>
  useContext(RegisterPendingItemDeletionContext);
